import {useClient, useDictionary} from '@adamlip/okeoke.client';
import {Card, CardBody, CardHeader} from '@heroui/react';
import {StoreIcon} from 'lucide-react';
import moment from 'moment';
import {NumericFormat} from 'react-number-format';

function SubmittedOrderHeader(props) {
	const {order, onClick} = props;

	const {locations} = useClient();
	const {getValue} = useDictionary();

	const handleClickOnHeader = () => {
		if (typeof onClick === 'function') onClick({orderUUID: order.uuid});
	};

	if (order == null) return null;

	return (
		<Card className=' shrink-0' fullWidth isPressable={typeof onClick === 'function'} onPress={handleClickOnHeader}>
			<CardHeader className='flex flex-col pb-0'>
				<div className='w-full flex flex-row items-center justify-center gap-2'>
					<StoreIcon className='w-5 h-5' />
					{locations != null && <div className=' text-left text-xl font-bold'>{locations?.[order?.locationUUID]?.name == null ? '' : locations?.[order?.locationUUID]?.name}</div>}
				</div>
				{order?.tableInfo != null && order?.tableInfo?.name && <div className='order-table-info font-small'>{order?.tableInfo?.name}</div>}
			</CardHeader>
			<CardBody className=''>
				{typeof onClick === 'function' && <div className=''>{getValue('app_v2_submittedOrder_goToDetails')}</div>}
				<div className='w-full text-center opacity-70 pt-4'>{getValue('app_v2_orderState_label')}</div>
				<div className='w-full text-center font-bold'>{getValue(`app_v2_orderState_${order.orderState}`)}</div>
				<div className='font-bold w-full text-right text-primary'>{<NumericFormat value={+order.discountPrice} decimalSeparator=',' suffix=' Ft' thousandSeparator='.' displayType='text' />}</div>
				<div className='text-xs opacity-70 w-full text-right'>{moment(order?.insertTimestamp).format('YYYY-MM-DD HH:mm')}</div>
			</CardBody>
		</Card>
	);
}

export default SubmittedOrderHeader;
